import React from 'react';
import { DialogProps } from '../type';
import Modal from '../../Modal';
import Button from '../../Button';
import { CheckCircleIcon as CheckCircleOutlineIcon } from '../../icons';

function SuccessDialog({
  id,
  title,
  content,
  onOk,
  okLabel,
  withoutIcon,
}: DialogProps) {
  return (
    <Modal
      id={id}
      {...(withoutIcon ? {} : { icon: <CheckCircleOutlineIcon /> })}
      type="dialog"
      isOpened={true}
      title={title}
      hasCloseFooterButton={false}
      primaryButton={
        <Button type="primary" isBlock={true} onClick={onOk}>
          {okLabel}
        </Button>
      }
    >
      {content}
    </Modal>
  );
}

SuccessDialog.defaultProps = {
  okLabel: 'Ok',
};

export default SuccessDialog;
